export const CATEGORY_COLOR = {
  General: "#a855f7",
  Environmental: "#10b981",
  Social: "#3b82f6",
  Governance: "#f59e0b",
};

export const FALLBACK_COLOR = "#94a3b8";

export const CATEGORY_RANK = {
  General: 0,
  Environmental: 1,
  Social: 2,
  Governance: 3,
};

export const UNRANKED = 99;

export const getCategoryColor = (category) =>
  CATEGORY_COLOR[category] ?? FALLBACK_COLOR;

export const rankCategory = (category) => CATEGORY_RANK[category] ?? UNRANKED;

export const filterBucketsByCategory = (buckets, pickedCategories) => {
  if (!pickedCategories || pickedCategories.size === 0) return buckets;
  return buckets.filter((b) => pickedCategories.has(b.category));
};
